import React, { useContext } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import PhoneInput from 'react-phone-number-input';
import metadata from 'libphonenumber-js/metadata.min.json';
import { RSVPContext } from '../../context';
import StickyFooter from '../../../../components/StickyFooter';
import { FlexFlow } from '../../../../components/styles/Layout';
import { CssTextField, PhoneInputWrapper } from '../../../../components/Forms/styles';
import genderData from '../../../../constants/gender';

import {
  LPText,
  ContentWrapper,
  CardTextArea,
} from '../../../styles';

const StepLanding = () => {
  const {
    contextData: {
      eventItemData,
      goToNextStep,
      goToLastStep,

      formData,
      setField,
      updateUsedFields,
      hasErrorMessage,
      isFormValid,

      saveData,
      mutationLoading,
    },
  } = useContext(RSVPContext);

  const {
    getVpn: {
      availableEvents,
    },
  } = eventItemData;

  const event = availableEvents[0];

  const {
    representationalMetadataList,
    location: {
      type,
    },
  } = event;

  const {
    firstName,
    lastName,
    zipCode,
    gender,
    primaryPhoneNumber,
  } = formData;

  const pageData = {
    instructions: '',
    btnLabel: '',
  };

  representationalMetadataList.forEach(({
    destination,
    content,
    type: metaType,
  }) => {
    if (destination === 'capture_page') {
      switch (metaType) {
        case 'BTN_LABEL':
          pageData.btnLabel = content;
          break;
        case 'INSTRUCTIONS':
          pageData.instructions = content;
          break;
        default:
          break;
      }
    }
  });

  const buttonAction = (type === 'VIRTUAL')
    ? () => saveData({ onSuccess: goToLastStep })
    : goToNextStep;

  let { btnLabel } = pageData;
  btnLabel = mutationLoading ? 'Submitting...' : btnLabel;

  return (
    <>
      <ContentWrapper>
        <LPText mb2>
          {pageData.instructions}
        </LPText>
        <FlexFlow grow shrink column splitSpace="1em">
          <FlexFlow nowrap splitSpace="1em">
            <CssTextField
              fullWidth
              margin="dense"
              variant="outlined"
              label="First Name"
              value={firstName}
              onChange={(e) => setField(e.target.value, 'firstName')}
              onBlur={() => updateUsedFields('firstName')}
              error={hasErrorMessage('firstName').length > 0}
              helperText={
                    hasErrorMessage('firstName').length > 0
                      ? hasErrorMessage('firstName').join(' | ')
                      : ''
                  }
            />
            <CssTextField
              fullWidth
              margin="dense"
              variant="outlined"
              label="Last Name"
              value={lastName}
              onChange={(e) => setField(e.target.value, 'lastName')}
              onBlur={() => updateUsedFields('lastName')}
              error={hasErrorMessage('lastName').length > 0}
              helperText={
                    hasErrorMessage('lastName').length > 0
                      ? hasErrorMessage('lastName').join(' | ')
                      : ''
                  }
            />
          </FlexFlow>
          <FlexFlow nowrap splitSpace="1em">
            <CssTextField
              select
              fullWidth
              margin="dense"
              variant="outlined"
              label="Gender"
              value={gender}
              onChange={(e) => setField(e.target.value, 'gender')}
              onBlur={() => updateUsedFields('gender')}
              error={hasErrorMessage('gender').length > 0}
              helperText={
                  hasErrorMessage('gender').length > 0
                    ? hasErrorMessage('gender').join(' | ')
                    : ''
                }
            >
              {genderData.map(({ value, label, id }) => (
                <MenuItem key={id} value={value}>
                  {label}
                </MenuItem>
              ))}
            </CssTextField>
            <CssTextField
              fullWidth
              type="number"
              margin="dense"
              variant="outlined"
              label="Zip/Postal code"
              value={zipCode}
              onChange={(e) => setField(e.target.value, 'zipCode')}
              onBlur={() => updateUsedFields('zipCode')}
              error={hasErrorMessage('zipCode').length > 0}
              helperText={
                  hasErrorMessage('zipCode').length > 0
                    ? hasErrorMessage('zipCode').join(' | ')
                    : ''
                }
            />
          </FlexFlow>
          <CardTextArea>
            <PhoneInputWrapper>
              <PhoneInput
                label="Phone"
                metadata={metadata}
                defaultCountry="US"
                placeholder="Mobile # (w/country code)"
                value={primaryPhoneNumber}
                onChange={(value) => setField(`${value}`, 'primaryPhoneNumber')}
                onBlur={() => updateUsedFields('primaryPhoneNumber')}
              />
            </PhoneInputWrapper>
            {hasErrorMessage('primaryPhoneNumber').length > 0 && (
            <LPText small error clear nomargin>
              {hasErrorMessage('primaryPhoneNumber').join(' | ')}
            </LPText>
            )}
          </CardTextArea>
          <LPText
            small
            clear
            nomargin
            warning={!isFormValid}
            success={isFormValid}
          >
            {!isFormValid
              ? '* All fields are required'
              : 'Looks good!'}
          </LPText>

          <LPText small centered>
            Clicking the SUBMIT button you agree to receive text-messages from me.
            You can opt-out at anytime by just texting STOP.
            Your carrier may charge you normal SMS or data rates.
          </LPText>
        </FlexFlow>
      </ContentWrapper>

      <StickyFooter
        disabled={!isFormValid}
        title={btnLabel}
        handleOnclick={buttonAction}
      />
    </>
  );
};

export default StepLanding;
